import { Component, OnInit } from '@angular/core';
import { Language } from '../../services/language.service';
import { Localized } from '../../../../objects';
import { ApiService } from '../../../../services/api.service';
import { DateAdapter } from '@angular/material/core';
import { MatDialogRef } from '@angular/material/dialog';
import { LanguageStyleService, LanguageStyle } from '../../services/language-style.service';
import { LectionaryItemNameService,  LectionaryItemNameSummary } from '../../services/lectionary-item-name.service';
import { LectionarySourceService, LectionarySource } from '../../services/lectionary-source.service';
import { LectionaryItemTypeService, LectionaryItemType } from '../../services/lectionary-item-type.service';
import { LectionaryItem, LectionaryItemService } from '../../services/lectionary-item.service';
import { EditEntityBaseClass } from '../EditEntityBaseClass';
import { PsalterService } from '../../services/psalter.service';  

@Component({
  selector: 'app-lectionary-item-edit',
  templateUrl: './lectionary-item-edit.component.html',
  styleUrls: ['./lectionary-item-edit.component.css']
})
export class LectionaryItemEditComponent extends EditEntityBaseClass implements OnInit {

  public item: LectionaryItem;
  public currentLanguageCode = "eng";
  public currentLanguage: Language;
  public currentLocalizedData: Localized;

  public lectionarySources: LectionarySource[];
  public lectionaryItemNames: LectionaryItemNameSummary[];
  public lectionaryItemTypes: LectionaryItemType[];
  public languageStyles: LanguageStyle[];

  public listsLoaded: boolean;
  public isLoadingLectionaryItemNames = false; 
  public saveButtonText = "Save";

  public isHtmlEditorReadOnly = false;
  private psalterHtml = "";
  public isPsalmDetected = false;

  public htmlEditedValue: string; //using this as a temporary variable for the results from the editor, until we're ready to save.

  constructor(
    private apiSvc: ApiService,
    private languageStyleSvc: LanguageStyleService,
    private lectionaryItemNameSvc: LectionaryItemNameService,
    private lectionarySourceSvc: LectionarySourceService,
    private lectionaryItemTypeSvc: LectionaryItemTypeService,
    private lectionaryItemSvc: LectionaryItemService,
    private dialog: MatDialogRef<LectionaryItemEditComponent>,
    private psalterSvc: PsalterService,
  ) {
    super();
   }

  ngOnInit() {
    this.listsLoaded = false;
  }


  public setModel(lectionaryItemId: number) {

    console.log("New item: ", lectionaryItemId);

    if (lectionaryItemId == null) {

      this.item = new LectionaryItem();

    } else {

      var itemPromise = this.lectionaryItemSvc.getItem(lectionaryItemId).then(
        (data) => {
          this.item = data;
          this.htmlEditedValue = data.HTML;

          this.isPsalmDetected = this.isPsalm(this.item);

          if (this.isPsalmDetected) {
            this.getPsalmText();
          }

          console.log(this.item);
          if (this.item.ProofedByName != "") {
            this.saveButtonText = "Save and Clear Proofing";
          }
          
          this.getLectionaryItemNames(this.item.LectionaryItemName.LectionaryItemType.Id);

        }
      );

    }
  }

  private isPsalm(item: LectionaryItem) {
    var lectionaryItemName = item.LectionaryItemName.Localized[0].Name;
 
    if (lectionaryItemName.toUpperCase().includes("PSALM")) {
      console.log("Psalm detected");
      return true;
    }

    return false;
  }

  private getPsalmText() {

    console.log("getPsalmtText", this.item);
 
    var languageStylePromise = this.psalterSvc.getPsalterHtml(this.item.LectionaryItemName.Localized[0].Name, this.item.LectionarySource.Id)
    .then(
      (data) => {
        this.psalterHtml = data;
        setTimeout(() => {

          this.isHtmlEditorReadOnly = true;
        }, 500);

      }
    )
    .catch((ex) => { 
      alert("Could not retrieve the Psalm HTML." + ex);
      console.log(ex);
    });

  }

  public setSelectedLanguage(language: Language) {

    console.log("setSelectedLangage", language);
    this.currentLanguage = language;


    var languageStylePromise = this.languageStyleSvc.loadEntities().then(
      (data) => {
        this.languageStyles = data;
      }
    );

    var lectionarySourcePromise = this.lectionarySourceSvc.loadEntites().then(
      (data) => {
        this.lectionarySources = data;
      }
    )

    var lectionaryItemTypePromise = this.lectionaryItemTypeSvc.loadEntities().then(
      (data) => {
        this.lectionaryItemTypes = data;
      }
    ) 

    Promise.all([languageStylePromise, lectionarySourcePromise, lectionaryItemTypePromise]).then(
      (data) => {
 
        console.log("All promises are completed");
        this.listsLoaded = true;
      }
    )

  }

  private getLectionaryItemNames(lectionaryItemTypeId: number) {
    
    this.lectionaryItemNames = [];

 
    console.log("getLectionaryItemNames", lectionaryItemTypeId);
    if (lectionaryItemTypeId == null) return; 

    this.isLoadingLectionaryItemNames = true; 
    var lectionaryItemNamePromise = this.lectionaryItemNameSvc.loadSummaryEntitiesByLectionaryItemTypeId(lectionaryItemTypeId).then(
      (data) => {
        this.lectionaryItemNames = data;
        this.isLoadingLectionaryItemNames = false; 
      }, 
      (err) => { 
        alert("Could not load the lectionary item names");
        console.log(err);
        this.isLoadingLectionaryItemNames = false;
      }
    );

  }

  private lecctionaryItemTypeValueChanged(e : any) { 
    console.log("lecctionaryItemTypeValueChanged EVENT:", e);
    //this.setModelValue(e, this.item.LectionaryItemType);
    this.getLectionaryItemNames(e);
  }
 
  public htmlChanged(e) { 
    this.htmlEditedValue = e; 
  }

  public cancel() {
    this.dialog.close();
  }


  public save(isProofed: boolean) {

    if (this.validate(this.htmlEditedValue) == false) {
      alert("Invalid characters detected in the HTML. Verify that you are not using \"curly\" quote marks in your HTML tags. \n\n For example. <p class='collectText'> should have straight quotes. Check the console for more details.");
      return;
    }
 
    this.item.HTML = this.htmlEditedValue;
  
    var payload = {
      Item: this.item,
      IsProofed: isProofed
    };
 
    console.log("Saving lectionary item", payload);

    this.apiSvc.post("api/lectionaryitem/save", payload).subscribe(
      (data: LectionaryItem) => {
        this.item = data;
        console.log(data);

        this.dialog.close(data);
      },
      (err) => {

          console.log(err);
  
          if (err.Message != undefined) {
            var msg = err.Message.split("|").join("\n"); 
            alert("Error:\n\n" + msg); 
            return;
          }


        if (err.status == 406) {  
          var errorReason = JSON.parse(err._body).reason; 
          alert("Error: " + errorReason);
        } else {
          var errorReason = JSON.parse(err._body).reason; 
          if (errorReason != undefined) {
            alert("Error: " + errorReason);
          }
          else { 
            alert("Cannot delete the LectionaryItemName");
          }
        }
        
      }
    );

  }

  public validateBeforeSave() {
    var result = this.validate(this.htmlEditedValue);

    if (result == true){
      alert("Passed");
    } else {
      alert("Did not pass validation. Check console for details");
    }
     
  }

  public validate(val: string): boolean {
 
    //https://www.npmjs.com/package/sanitize-html
 
    if (val.includes("class=’")) return false;
    if (val.includes("class=“")) return false;
    if (val.includes("”>")) return false;
    if (val.includes("” >")) return false;
    if (val.includes("’>")) return false;
 
    var sanitizedHtml =  val.replace(/(<([^>]+)>)/ig,"");// sanitizeHtml(val);
   
    var characters = [
      '“',
      '”',
      '‘',
      '’',
      '′',
      '"',
      '\'',   //single quote
      '–',    //en dash
      '—'     //em dash 
    ];

    var isValid = true;
    characters.forEach(char => {

      if (sanitizedHtml.includes(char)) {
        console.log("Invalid character detected", char);
        isValid = false; 
      }

    }); 
    
    return isValid;
  }

} 